// extracted by mini-css-extract-plugin
export var legendIndicator = "_g0-1";
export var legendRight = "_g0-0";